import store from './store';
import CONSTANTS from './constants';
import { EventBus } from './event-bus.js';

window.axios.interceptors.response.use(null, function (error) {
    switch (error.response.status) {
        case 422:
            store.commit(`formErrors/${CONSTANTS.MUTATIONS.PUSH_ERRORS}`, error.response.data.errors);
            if (error.response.data && error.response.data.errors && error.response.data.errors[CONSTANTS.DEFAULT_ERROR_FIELD]) {
                error.response.data.errors[CONSTANTS.DEFAULT_ERROR_FIELD].map(message => {
                    EventBus.$emit('event-error', message);
                });
            }
            break;
        case 423:
            if (error.response.data && error.response.data.message) {
                EventBus.$emit('event-error', error.response.data.message);
            }
            location.href = '/';
            break;
        case 500:
            EventBus.$emit('event-error', error.response.data.message);
            // EventBus.$emit('event-error', 'Something went terribly wrong!');
            break;
        default:
            if (error.response.data && error.response.data.message) {
                EventBus.$emit('event-error', error.response.data.message);
            }
            break;
    }
    return Promise.reject(error);
});


// WEBPACK FOOTER //
// ./resources/assets/js/axios-interceptor.js